import { RefreshCw } from 'lucide-react'

interface ErrorMessageProps {
  message: string
  onRetry: () => void
}

export function ErrorMessage({ message, onRetry }: ErrorMessageProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <div className="text-6xl mb-4">😕</div>
      <h3 className="text-2xl font-bold text-gray-800 mb-2">Oops!</h3>
      <p className="text-gray-600 mb-6 text-center max-w-md">{message}</p>
      <button
        onClick={onRetry}
        className="flex items-center space-x-2 bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-full font-medium transition-colors"
      >
        <RefreshCw className="w-5 h-5" />
        <span>Try Again</span>
      </button>
    </div>
  )
}